<template>
  <div>
    <loader v-if="is.loading" />
    <template v-else>
      <order-basket :order="entity" :order-data="orderData" :order-tasks="productTasks" @update-order="onUpdateOrder" @task-resolved="onTaskResolved" />
      <br />
      <order-actions :entityKey="eParent.key" :order="entity" />
    </template>

  </div>
</template>

<script>
import Loader from '@/components/Loader';
import MixinEntityBase from '@/components/mixins/EntityBase';
import OrderActions from '@/components/order/OrderActions';
import OrderBasket from '@/components/order/orderly/OrderBasket';

export default {
  name: 'Orders.Detail',
  mixins: [MixinEntityBase],
  components: {
    OrderBasket,
    Loader,
    OrderActions
  },
  data() {
    return {
      orderData: null,
      orderDataLoaded: false,
      allOrderlyTasks: [], // Store all tasks, not just incomplete ones
      productTasksLoaded: false
    }
  },
  computed: {
    is() {
      return this.$store.getters[`${this.eParent.key}/is`]
    },
    entity() {
      return this.$store.getters[`${this.eParent.key}/getEntityUnwrapped`](this.eParent.id) || {}
    },
    orderlyTasks() {
      // Filter incomplete tasks reactively
      return this.allOrderlyTasks.filter(task => task.isCompleted === false)
    },
    productTasks() {
      return this.orderlyTasks.filter(task => task.section === 'Products')
    }
  },
  mounted() {
    this.$store.dispatch('orderparsedata/getByOrderId', { orderId: this.eParent.id })
      .then(response => {
        this.orderData = response.result
        this.orderDataLoaded = true
      })
      .then(() => {
        this.$store.dispatch('orderlytasks/getByOrderParseDataId', { orderParseDataId: this.orderData.id })
          .then(response => {
            this.allOrderlyTasks = response.result // Store all tasks
            this.productTasksLoaded = true
          })
      })
      .catch(error => {
        console.error(error)
      })
  },
  methods: {
    getProductDescription(extractId, searchId) {
      const products = this.orderData.extractorResult.products
      const product = products.find(p => p.id === extractId)

      if (!product) {
        return 'Unbekanntes Produkt'
      }

      return product.productQuery || product.productIds.join(', ')
    },
    onTaskResolved(taskId) {
      this.$store.dispatch('orderlytasks/getByOrderParseDataId', { orderParseDataId: this.orderData.id })
        .then(response => {
          this.allOrderlyTasks = response.result // Store all tasks - filtering is now reactive
          this.productTasksLoaded = true
        })
    },
    onUpdateOrder(order) {
      // The store is already updated by the updateOrderItem action via setBasketItem mutation
      // No need to reload the entire order from the API - this was causing scroll-to-top
    }
  }
}
</script>

<style lang="scss"></style>
